import {Injectable} from '@angular/core';
import {MedicalRecordPainModel} from '../../api/model/medicalRecordPain.model';
import {MedicalRecordPainCreateUpdatePayload} from './payload/save/medicalRecordPainCreateUpdate.payload';
import {EntityCollectionServiceBase} from '@ngrx/data';
import {
    MedicalRecordVisitReasonRepository
} from '../../../visit-reason/impl/service/ngrx/medicalRecordVisitReason.repository';
import {AbstractSaveOneService} from '../../../../../core/service/v2/service/save/abstractSaveOne.service';
import {MedicalPainRepository} from './ngxr/medicalPain.repository';
import {MedicalPainDataServiceAdapter} from './ngxr/medicalPainDataService.adapter';

@Injectable()
export class MedicalPainSaveOneService extends
    AbstractSaveOneService<MedicalRecordPainModel, MedicalRecordPainCreateUpdatePayload>{

    constructor(public service: MedicalPainRepository,
                public dataService: MedicalPainDataServiceAdapter,
                public visitReasonRepository: MedicalRecordVisitReasonRepository) {
        super(service, dataService);
    }

    protected getRepositoriesToSynchronize(): EntityCollectionServiceBase<any>[] {
        return [
            this.visitReasonRepository
        ];
    }

}
